import EmbeddedDocService from '@/services/bytepro/embeddedDoc.service';

export const embeddedDoc = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    get({ commit }, fileDataId){
      return EmbeddedDocService.get(fileDataId).then(
        resp => {
          commit('dummy', "get - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "get - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    }
  }
};